import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import promocodesReducer from './slices/promocodes';
import promoReducer from './slices/promo';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import notificationWithdrawsReducer from './slices/notification-withdraws';
import pagePaginationReducer from './slices/page-pagination';

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

export const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

export const promocodePersistConfig = {
  key: 'promocode',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

export const promoPersistConfig = {
  key: 'promo',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  pagePagination: pagePaginationReducer,
  notificationWithdraws: notificationWithdrawsReducer,
  product: persistReducer(productPersistConfig, productReducer),
  prmocode: persistReducer(promocodePersistConfig, promocodesReducer),
  promo: persistReducer(promoPersistConfig, promoReducer),
});

export default rootReducer;
